import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addToHistory } from 'src/redux/app/actions';
import { basepathSelector } from 'src/redux/app/selectors';
import { setFeatureCards } from 'src/redux/bikes/actions';

export const ScrollToTop = ({ children, location }) => {
  const dispatch = useDispatch();
  const basepath = useSelector(basepathSelector);

  useEffect(() => {
    window.scrollTo(0, 0);
    let route = location.pathname.replace(basepath, '');

    if (route[0] !== '/') {
      route = `/${route}`;
    }

    dispatch(addToHistory(route));
    dispatch(setFeatureCards({ type: 'family', features: [] }));
  }, [basepath, dispatch, location.pathname]);

  return children;
};
